import { BorderRadiusCss } from "@tvg/fuse-utils";

const config = {
  componentName: "fuse-search-field",
};

const styledInputConfig = {
  borderRadius: BorderRadiusCss("l"),
  borderWidth: "1px",
  componentName: config.componentName,
  fieldName: "term",
  maxLength: 150,
  maskIconButton: {
    color: "var(--color-global-grey800)",
    size: "small",
  },
  helperTextColor: {
    error: "var(--color-functional-errorMid)",
    success: "var(--color-global-grey800)",
  },
};

export { config, styledInputConfig };
